<template>
	<ao-range-sliders
		:model-value="modelValue"
		:min="min"
		:max="max"
		:step="step"
		:componentPayload="componentPayload"
		showInputs
		:valueFormatterCallback="formatValue"
		:canChangeFromInput="false"
		@update:modelValue="
			(value) => {
				$emit('update:modelValue', value)
			}
		"
	/>
</template>

<script>
import useMoment from '@/composables/useMoment'

export default {
	name: 'AoRangeDurationSliders',

	props: {
		modelValue: {
			type: Array,
			default: [null, null],
		},

		label: {
			type: String,
			default: '',
		},

		density: {
			type: String,
			default: 'compact',
		},

		thumbSize: {
			type: Number,
			default: 16,
		},

		numbered: {
			type: Boolean,
			default: false,
		},

		color: {
			type: String,
			default: 'primary',
		},

		min: Number,

		max: Number,

		step: {
			type: Number,
			default: 1,
		},

		showInputs: Boolean,

		componentPayload: {
			type: Object,
			default: () => ({}),
		},

		error: {
			type: Boolean,
			default: false,
		},

		errorMessages: {
			type: Array || String,
			default: [null],
		},

		// Return null if min or max equal to value
		returnNullable: {
			type: Boolean,
			default: true,
		}
	},

	emits: ['update:modelValue'],

	setup() {
		const { makeDurationFormatterFromSeconds } = useMoment()

		const formatValue = (value) => {
			return makeDurationFormatterFromSeconds(value, { showDays: false })
		}

		return {
			formatValue,
		}
	},
}
</script>
